import categories from './categories'

export default {
  categories,
  welcome: `{0} {1} 欢迎你！`,
  upload: `文件上传`,
  share: `我的分享1111`,
  edit: `我的编辑`,
  login_title: `联想云存储系统`,
  login_inputUsername: `请输入用户名`,
  login_submit_text: `确定`,
  upload_progress_text: `正在上传{0}个（共{1}个）文件...`,
  upload_complete_text: `{0}个文件传输完成`,
  message_dynamic_create_folder: '{0}新建了一个文件夹"{1}"',
  message_dynamic_upload_file: '{0}上传了一个文件"{1}"',
  message_dynamic_upload_folder: '{0}上传了一个文件"{1}"',
  message_dynamic_update_file: '{0}更新了一个文件"{1}"',
  message_dynamic_add_auth: '{0}在文件夹"{1}"为您授予了"{2}"权限',
  message_dynamic_update_auth: '{0}在文件夹"{1}"将您的权限由"{2}"修改为"{3}"',
  message_dynamic_delete_auth: '{0}删除了您在文件夹"{1}"的权限',
  message_dynamic_add_auth_for_share_folder: '{0}在共享文件夹"{1}"为您授予了"{2}"权限',
  message_dynamic_update_auth_for_share_folder: '{0}在共享文件夹"{1}"将您的权限由"{2}"修改为"{3}"',
  message_dynamic_delete_auth_for_share_folder: '{0}删除了您在共享文件夹"{1}"的权限',
  message_dynamic_hand_over_share_folder_self: '您的共享文件夹"{0}"被管理员移交给了"{1}"',
  message_dynamic_hand_over_share_folder: '管理员将"{0}"的共享文件夹"{1}"移交给了您',
  message_dynamic_update_user_name: '管理员将您的姓名更新为{0}',
  message_dynamic_update_user_mail: '管理员将您的邮箱信息更新为{0}',
  message_dynamic_update_user_phone: '管理员将您的手机号信息更新为{0}',
  message_dynamic_update_user_datacenter: '管理员将您的个人本地空间调整为{0}',
  message_dynamic_open_user_space: '管理员开启了您的个人本地空间，空间大小为{0}，并将您所属数据中心配置为{1}',
  message_dynamic_update_user_space: '管理员将您的个人本地空间调整为{0}',
  message_dynamic_close_user_space: '管理员关闭了您的个人本地空间',
  message_dynamic_open_user_cloud_space: '管理员开启了您的个人云空间，空间大小为{0}',
  message_dynamic_update_user_cloud_space: '管理员将您的个人云空间调整为{0}',
  message_dynamic_close_user_cloud_space: '管理员关闭了您的个人云空间',
  message_dynamic_open_enterprise_cloud_space: '管理员开启了企业云空间',
  message_dynamic_update_enterprise_cloud_space: '管理员更新了企业云空间',
  message_dynamic_close_enterprise_cloud_space: '管理员关闭了企业云空间',
  message_dynamic_open_speed_limit: '管理员为您开启了客户端传输限速，上传阀值为{0},下载阀值为{1}',
  message_dynamic_update_upload_speed: '管理员将您的客户端上传限速阀值调整为{0}',
  message_dynamic_update_download_speed: '管理员将您的客户端下载限速阀值调整为{0}',
  message_dynamic_close_speed_limit: '管理员关闭了您的客户端限速',
  message_comment_content: '{0}在"{1}"中提到了你'
}



// WEBPACK FOOTER //
// ./src/lang/zh/index.js